import React, { useMemo } from "react";
import { StatsContext } from "./contexts";
import { useCompaniesCount, useJobPostCount, useHcDomainList } from "@/hooks";

interface StatsProviderProps {
  children: React.ReactNode;
}

export function StatsProvider({ children }: StatsProviderProps) {
  const {
    count: companies,
    loading: companiesLoading,
    error: companiesError,
  } = useCompaniesCount();

  const {
    count: jobPosts,
    loading: jobPostsLoading,
    error: jobPostsError,
  } = useJobPostCount();

  const {
    totalDomains: healthcareDomains,
    loading: healthcareDomainsLoading,
    error: healthcareDomainsError,
  } = useHcDomainList();

  const combinedLoading =
    companiesLoading || jobPostsLoading || healthcareDomainsLoading;
  const combinedError =
    companiesError || jobPostsError || healthcareDomainsError;

  const totalCompanies = companies ? companies : 0;
  const totalJobPosts = jobPosts ? jobPosts : 0;
  const totalHealthcareDomains = healthcareDomains ? healthcareDomains : 0;

  const value = useMemo(
    () => ({
      totalCompanies,
      totalJobPosts,
      totalHealthcareDomains,
      error: combinedError,
      loading: combinedLoading,
    }),
    [
      totalCompanies,
      totalJobPosts,
      totalHealthcareDomains,
      combinedError,
      combinedLoading,
    ],
  );

  return (
    <StatsContext.Provider value={value}>{children}</StatsContext.Provider>
  );
}
